/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaderboardPrizeTierResponse } from './LeaderboardPrizeTierResponse';
import {
    LeaderboardPrizeTierResponseFromJSON,
    LeaderboardPrizeTierResponseFromJSONTyped,
    LeaderboardPrizeTierResponseToJSON,
    LeaderboardPrizeTierResponseToJSONTyped,
} from './LeaderboardPrizeTierResponse';
import type { PrizePoolMode } from './PrizePoolMode';
import {
    PrizePoolModeFromJSON,
    PrizePoolModeFromJSONTyped,
    PrizePoolModeToJSON,
    PrizePoolModeToJSONTyped,
} from './PrizePoolMode';

/**
 * 
 * @export
 * @interface LeaderboardPrizePoolResponse
 */
export interface LeaderboardPrizePoolResponse {
    /**
     * Sponsor-facing display value for prize-based competitions
     * @type {number}
     * @memberof LeaderboardPrizePoolResponse
     */
    totalValue: number;
    /**
     * ISO/symbolic code for totalValue (FUEL, USD, etc.)
     * @type {string}
     * @memberof LeaderboardPrizePoolResponse
     */
    currency: string;
    /**
     * Devour-funded amount in USD dollars committed to the winner pool. Under FIXED pool mode this IS the pool; under ENTRY_SCALED it is a floor. Requires a payoutTableId. Snapshotted to the period's escrow as USD at first-participant-join; conversion to FUEL happens at distribution time using the FUEL price at payout. Intentionally surfaced publicly — the marketing intent of the field is to enlarge the displayed prize pool.
     * @type {number}
     * @memberof LeaderboardPrizePoolResponse
     */
    guaranteedPoolUsd?: number;
    /**
     * 
     * @type {PrizePoolMode}
     * @memberof LeaderboardPrizePoolResponse
     */
    poolMode?: PrizePoolMode;
    /**
     * 
     * @type {Array<LeaderboardPrizeTierResponse>}
     * @memberof LeaderboardPrizePoolResponse
     */
    tiers: Array<LeaderboardPrizeTierResponse>;
    /**
     * PENDING, IN_PROGRESS, COMPLETED, PARTIAL
     * @type {string}
     * @memberof LeaderboardPrizePoolResponse
     */
    distributionStatus: string;
    /**
     * Live escrow pool in FUEL before the platform fee. Populated by the detail endpoint for ENTRY_FEE boards.
     * @type {number}
     * @memberof LeaderboardPrizePoolResponse
     */
    totalValueFuel?: number;
    /**
     * Live winner pool in FUEL after the platform fee. Populated by the detail endpoint for ENTRY_FEE boards.
     * @type {number}
     * @memberof LeaderboardPrizePoolResponse
     */
    winnerPoolFuel?: number;
    /**
     * Live winner pool in display units — USD when isUsdMode, FUEL otherwise. Includes the guaranteed-pool floor. Populated by the detail endpoint for ENTRY_FEE boards.
     * @type {number}
     * @memberof LeaderboardPrizePoolResponse
     */
    winnerPool?: number;
    /**
     * Paid entries counted into the live pool. Populated by the detail endpoint for ENTRY_FEE boards.
     * @type {number}
     * @memberof LeaderboardPrizePoolResponse
     */
    participantCount?: number;
    /**
     * Platform fee percentage applied to entries. Populated by the detail endpoint for ENTRY_FEE boards.
     * @type {number}
     * @memberof LeaderboardPrizePoolResponse
     */
    platformFeePercent?: number;
    /**
     * True when the board's entry fee is USD_EQUIVALENT-priced — totalValue/winnerPool/calculatedAmount are then USD figures.
     * @type {boolean}
     * @memberof LeaderboardPrizePoolResponse
     */
    isUsdMode?: boolean;
}



/**
 * Check if a given object implements the LeaderboardPrizePoolResponse interface.
 */
export function instanceOfLeaderboardPrizePoolResponse(value: object): value is LeaderboardPrizePoolResponse {
    if (!('totalValue' in value) || value['totalValue'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('tiers' in value) || value['tiers'] === undefined) return false;
    if (!('distributionStatus' in value) || value['distributionStatus'] === undefined) return false;
    return true;
}

export function LeaderboardPrizePoolResponseFromJSON(json: any): LeaderboardPrizePoolResponse {
    return LeaderboardPrizePoolResponseFromJSONTyped(json, false);
}

export function LeaderboardPrizePoolResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardPrizePoolResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalValue': json['totalValue'],
        'currency': json['currency'],
        'guaranteedPoolUsd': json['guaranteedPoolUsd'] == null ? undefined : json['guaranteedPoolUsd'],
        'poolMode': json['poolMode'] == null ? undefined : PrizePoolModeFromJSON(json['poolMode']),
        'tiers': ((json['tiers'] as Array<any>).map(LeaderboardPrizeTierResponseFromJSON)),
        'distributionStatus': json['distributionStatus'],
        'totalValueFuel': json['totalValueFuel'] == null ? undefined : json['totalValueFuel'],
        'winnerPoolFuel': json['winnerPoolFuel'] == null ? undefined : json['winnerPoolFuel'],
        'winnerPool': json['winnerPool'] == null ? undefined : json['winnerPool'],
        'participantCount': json['participantCount'] == null ? undefined : json['participantCount'],
        'platformFeePercent': json['platformFeePercent'] == null ? undefined : json['platformFeePercent'],
        'isUsdMode': json['isUsdMode'] == null ? undefined : json['isUsdMode'],
    };
}

export function LeaderboardPrizePoolResponseToJSON(json: any): LeaderboardPrizePoolResponse {
    return LeaderboardPrizePoolResponseToJSONTyped(json, false);
}

export function LeaderboardPrizePoolResponseToJSONTyped(value?: LeaderboardPrizePoolResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalValue': value['totalValue'],
        'currency': value['currency'],
        'guaranteedPoolUsd': value['guaranteedPoolUsd'],
        'poolMode': PrizePoolModeToJSON(value['poolMode']),
        'tiers': ((value['tiers'] as Array<any>).map(LeaderboardPrizeTierResponseToJSON)),
        'distributionStatus': value['distributionStatus'],
        'totalValueFuel': value['totalValueFuel'],
        'winnerPoolFuel': value['winnerPoolFuel'],
        'winnerPool': value['winnerPool'],
        'participantCount': value['participantCount'],
        'platformFeePercent': value['platformFeePercent'],
        'isUsdMode': value['isUsdMode'],
    };
}

